//src/contexts/SessionContext.jsx

import React, { createContext, useContext, useState, useEffect } from "react";
import SessionExpiredModal from "../components/common/SessionExpiredModal";

const SessionContext = createContext();
export const useSession = () => useContext(SessionContext);

export function SessionProvider({ children }) {
  const [expired, setExpired] = useState(false);
  const [seconds, setSeconds] = useState(5);

  const triggerExpiration = () => {
    if (expired) return;

    setExpired(true);
    setSeconds(5);

    let counter = 5;
    const interval = setInterval(() => {
      counter--;
      setSeconds(counter);

      if (counter <= 0) {
        clearInterval(interval);

        // Limpa sessão
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        // Redireciona
        window.location.href = "/login";
      }
    }, 1000);
  };

  // 🔥 Permite que api.js acese triggerExpiration()
  useEffect(() => {
    window.sessionCallbacks = {
      triggerExpiration,
    };
  }, []);

  return (
    <SessionContext.Provider value={{ triggerExpiration }}>
      {children}
      <SessionExpiredModal show={expired} seconds={seconds} />
    </SessionContext.Provider>
  );
}
